import { InputInvalid } from '~components'
import * as Styled from './styled'

function Error({ children }) {
  return (
    <Styled.PopoverError>
      <InputInvalid />
      {children}
    </Styled.PopoverError>
  )
}

export default Error
